import { SimError } from "./SimError.js";
class MethodNoSuch extends SimError {
  constructor(message, name, propertyKeys, stack) {
    super(message, name, stack);
    this.propertyKeys = propertyKeys;
  }
}
export {
  MethodNoSuch
};
//# sourceMappingURL=MethodNoSuch.js.map
